/**
 * Email validation as per RFC2822 standards
 *
 * [a-z0-9!#$%&'*+/=?^_`{|}~-]+                    = One or more characters in the set
 * (\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*               = Zero or more characters in the set (also ensures that the last digit isn't a dot)
 * @                                               = Check for @ symbol
 * ([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+     = Start with a letter or number, followed by any letter, number or a dash, finishing with a dot
 * [a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$          = First character is necessarily a letter or number, followed 0 or more letters, numbers or dashes, finishing with a letter or number
 */
export const EMAIL_RULE_REGEX = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
/**
 * Make sure this explains EMAIL_RULE_REGEX
 */
export const EMAIL_RULE_MESSAGE = `Please enter a valid email address`.trim();
/**
 * Rule structure for react-hook-form
 */
export const EMAIL_RULE = {
    message: EMAIL_RULE_MESSAGE,
    value: EMAIL_RULE_REGEX,
};
/**
 * (?=.*[a-z])        = Check for lowercase letter
 * (?=.*\d)           = Check for digit
 * (?=.*[^\da-zA-Z])  = Check for non-digit and non-letter (^ negates the [] section)
 * .{8,}              = Make sure it is at least 8 characters, no maximum
 */
export const PASSWORD_RULE_REGEX = /^(?=.*[a-z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/;
/**
 * Make sure this explains PASSWORD_RULE_REGEX
 */
export const PASSWORD_RULE_MESSAGE = `
  Password must be at least 8 characters and 
  include at least one number, 
  at least one lowercase letter, 
  at least one non letter or digit
`.trim();
/**
 * Rule structure for react-hook-form
 */
export const PASSWORD_RULE = {
    message: PASSWORD_RULE_MESSAGE,
    value: PASSWORD_RULE_REGEX,
};
/**
 * One letter followed by either one or two numbers
 * OR
 * One letter followed by a second letter that must be one of ABCDEFGHJKLMNOPQRSTUVWXY (i.e..not I or Z) and then followed by either one or two numbers
 * OR
 * One letter followed by one number and then another letter
 * OR
 * A two part post code where the first part must be:
 * a) One letter followed by a second letter that must be one of ABCDEFGHJKLMNOPQRSTUVWXY(i.e..not I or Z) and then followed by one number and
 * optionally a further letter after that
 * AND
 * b) The second part (separated by a space from the first part) must be One number followed by two letters.
 */
export const POSTCODE_RULE_REGEX = /^(([A-Za-z][0-9]{1,2})|(([A-Za-z][A-HJ-Ya-hj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-HJ-Ya-hj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2}$/;
/**
 * Make sure this explains POSTCODE_RULE_REGEX
 */
export const POSTCODE_RULE_MESSAGE = `Please enter a valid postcode`.trim();
/**
 * Rule structure for react-hook-form
 */
export const POSTCODE_RULE = {
    message: POSTCODE_RULE_MESSAGE,
    value: POSTCODE_RULE_REGEX,
};
/**
 * Rule structure for react-hook-form
 */
export const TELEPHONE_RULE = {
    message: `Please enter a valid phone number`,
    value: /^[\d+()\-x ]{10,11}$/,
};
/** Clamp index to be within the min/max index range. */
export function clamp(value, max) {
    return Math.max(Math.min(value, max), 0);
}
